import React, { useState } from 'react';
import GenericUploader from 'Components/Files/GenericUploader/Uploader';
import PropTypes from 'prop-types';
import BlueCard from 'Components/ComponentLibrary/Components/Uncategorized/BlueCard/index';

// NOTE: refer 'Components/Files/Uploader' for potentially supported props
// feel free to include additional props by referring the component above
export default function FileUploaderCard({
  uploadURL,
  media,
  title,
  onStart,
  onCatch,
  onFinally,
  successToastMessage,
  children,
  disableClick,
  LoaderProps,
}) {
  const [uploading, setUploading] = useState(false);
  const disabled = uploading || disableClick;

  async function handleStart() {
    setUploading(true);
    if (onStart) {
      await Promise.resolve(onStart());
    }
  }

  async function handleFinally() {
    if (onFinally) {
      await Promise.resolve(onFinally());
    }
    setUploading(false);
  }

  return (
    <GenericUploader
      url={uploadURL}
      onStart={handleStart}
      onCatch={onCatch}
      onFinally={handleFinally}
      displaySuccessToastMessage={!!successToastMessage}
      successToastMessage={successToastMessage}
      disableClick={disabled}
    >
      <BlueCard label={title} loading={uploading} disabled={disabled} LoaderProps={LoaderProps} media={media}>
        {children}
      </BlueCard>
    </GenericUploader>
  );
}
FileUploaderCard.defaultProps = {
  successToastMessage: undefined,
  onStart: undefined,
  onCatch: undefined,
  onFinally: undefined,
  disableClick: false,
  children: undefined,
  LoaderProps: {},
};
FileUploaderCard.propTypes = {
  uploadURL: PropTypes.string.isRequired,
  media: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  successToastMessage: PropTypes.string,
  onStart: PropTypes.func,
  onCatch: PropTypes.func,
  onFinally: PropTypes.func,
  disableClick: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  LoaderProps: PropTypes.object,
};
